import './homepage.css';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ApexChart from "./charts";
import ListIcon from '../../images/ListIcon.png';
import manageIcon from '../../images/manageIcon.png';
import pendingIcon from '../../images/pendingIcon.png';
import resolve from '../../images/resolved.png';
import unresolve from '../../images/unresolved.png';
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { STAKEHOLDER_COUNT } from '../../common/URLs';
import { Navigate } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { Card, CardContent, Stack } from '@mui/material';
// import GoogleMapReact from 'google-map-react';
import Shortlisted from '../registration/shortlisted';
import apiClient from '../../axios';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));




function Home() {
  const [stakeholderCount, setStakeholderCount] = useState();
  useEffect(() => {
    gellAllStakeholderCount();

  }, []);
  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      const decoded = jwt(getLocalStorageItem('id_token'));
    }
  }, [getLocalStorageItem('id_token')]);

  function gellAllStakeholderCount() {
    apiClient
      .post(STAKEHOLDER_COUNT,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderCount(response.data);
      })
      .catch(function (error) {
      });
  }
  const activeApplications = stakeholderCount?.stakeHolderCounts[0]?.count;
  const shorlisted = stakeholderCount?.stakeHolderCounts[1]?.count;
  const waitlisted = stakeholderCount?.stakeHolderCounts[2]?.count;
  const newRegistrations = stakeholderCount?.stakeHolderCounts[3]?.count;
  const navigate = useNavigate();
  function viewAllWaitlistedStakeholders(e) {
    e.preventDefault();
    navigate("/viewAllStakeholders", { state: { status: "Waitlisted" } });
  }
  function viewAllShortlistedStakeholders(e) {
    e.preventDefault();
    navigate("/viewAllStakeholders", { state: { status: "Shortlisted" } });
  }
  function viewAllPreRegStakeholders(e) {
    e.preventDefault();
    navigate("/viewAllStakeholders", { state: { status: "Pre_Registration_Initiated" } });
  }
  function viewAllStakeholders(e) {
    e.preventDefault();
    navigate("/viewAllStakeholders", { state: { status: "All" } });
  }

  return (
      <Grid container spacing={1}>
        <Grid item xs={12} lg={5}>
          <Card style={{ borderRadius: 10 }}>
            <CardContent>
              <Typography style={{fontWeight: 'bold'}}>Registered Stakeholders </Typography>
              <ApexChart></ApexChart>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={7}>
          <Card style={{borderRadius: 10, height: '100%'}}>
            <CardContent>
              <Typography style={{fontWeight: 'bold'}}> MapView </Typography>
              <Typography> Coming Soon..!!</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Stack direction='row'  spacing={1}>
          <Grid item xs={12} lg={6}>
            <Card style={{ borderRadius: 10 }}>
              <CardContent>
                <a href='' onClick={(e) => viewAllStakeholders(e)} style={{float: 'right'}}>View All </a>
                <Typography style={{fontWeight: 'bold'}} >{activeApplications}</Typography>
                <Typography >Active Applications</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Card style={{ borderRadius: 10 }}>
              <CardContent>
                <a href='' onClick={(e) => viewAllStakeholders(e)} style={{float: 'right'}}>View All </a>
                <Typography style={{fontWeight: 'bold'}} >{newRegistrations}</Typography>
                <Typography >New Registrations</Typography>
              </CardContent>
            </Card>
          </Grid>
          </Stack>
          <Stack direction='row' spacing={1} style={{marginTop: 5}}>
          <Grid item xs={12} lg={6}>
            <Card style={{ borderRadius: 10 }}>
              <CardContent>
                <a href='#' onClick={(e) => viewAllWaitlistedStakeholders(e)} style={{float: 'right'}}>View All </a>
                <Typography style={{fontWeight: 'bold'}}>{shorlisted}</Typography>
                <Typography >Shortlisted</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Card style={{ borderRadius: 10 }}>
              <CardContent>
                <a href='#' onClick={(e) => viewAllWaitlistedStakeholders(e)} style={{float: 'right'}}>View All </a>
                <Typography style={{fontWeight: 'bold'}}>{waitlisted}</Typography>
                <Typography>Waitlisted</Typography>
              </CardContent>
            </Card>
          </Grid>
          </Stack>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Card style={{height: '100%', borderRadius: 10}}>
            <CardContent>
              <Typography style={{fontWeight: 'bold'}}> Issue Raised </Typography>
              <Typography> Coming Soon..!!</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Card style={{ borderRadius: 10 }}>
            <CardContent>
              <Stack direction='row' spacing={2}>
              <img class="list-icon" src={ListIcon} alt="list-icon" />
              <div>
              <Typography style={{fontWeight: 'bold'}}> Upcoming Tasks</Typography>
              <Typography> Coming Soon..!!</Typography>
              </div>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Card style={{ borderRadius: 10 }}>
            <CardContent>
            <Stack direction='row' spacing={2}>
            <img class="manage-icon" src={manageIcon} alt="manage-icon" />
              <div>
              <Typography style={{fontWeight: 'bold'}}> Manage Scrutiniser </Typography>
              <Typography> Coming Soon..!!</Typography>
              </div>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Card style={{ borderRadius: 10 }}>
            <CardContent>
            <Stack direction='row' spacing={2}>
            <img class="pending-icon" src={pendingIcon} alt="pending-icon" />
              <div>
              <Typography style={{fontWeight: 'bold'}}> Pending Tasks </Typography>
              <Typography> Coming Soon..!!</Typography>
              </div>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

      </Grid>

  );
}
export default Home;

